import { Controller } from "@hotwired/stimulus"

// Per-message reactions toggle. Click an existing chip → DELETE, click a new
// emoji from the bar → POST. The actual rendering of the updated chips list
// is driven by the `chat-thread` cable handler so the bubble stays in sync
// across all members.
const ALLOWED = ["👍", "❤️", "😂", "😮", "😢", "🔥"]

export default class extends Controller {
  static targets = ["chips"]
  static values  = { messageId: Number }

  toggle(event) {
    const emoji = event.params?.emoji
    if (!emoji || !ALLOWED.includes(emoji)) return
    event.preventDefault()

    const chip = event.currentTarget
    const isOwn = chip.classList?.contains?.("is-own")
    const path = `/intervenant/messages/${this.messageIdValue}/reactions/${encodeURIComponent(emoji)}`
    const method = isOwn ? "DELETE" : "POST"

    fetch(path, {
      method,
      headers: {
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
      body: method === "POST" ? JSON.stringify({ emoji }) : null,
    }).catch(() => {})
  }

  openBar(event) {
    event?.preventDefault?.()
    // Surface the existing _reactions_bar partial near the click target.
    // We render it inline so we don't need an extra HTTP roundtrip.
    const bubble = event.currentTarget.closest(".message")?.querySelector(".message__bubble")
    if (!bubble) return
    const existing = bubble.querySelector(".reactions-bar")
    if (existing) {
      existing.remove()
      return
    }
    const bar = document.createElement("div")
    bar.className = "reactions-bar"
    bar.dataset.messageId = String(this.messageIdValue)
    ALLOWED.forEach((emoji) => {
      const b = document.createElement("button")
      b.type = "button"
      b.className = "reactions-bar__btn"
      b.dataset.action = "reactions#toggle"
      b.dataset.reactionsEmojiParam = emoji
      b.textContent = emoji
      bar.appendChild(b)
    })
    bubble.prepend(bar)
  }
}

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ""
}
